<div class="prizes_container">

  <div class="info hidden-sm hidden-xs">
    <img src="assets/img/reno-cup/reno-cup-logo.png" alt="" width="200">
    <h1><span>Born to win</span> <br> prizes</h1>
  </div>
  <perfect-scrollbar>
    <div class="prize_info">
      <div class="item">
        <h1>Fun Challenges</h1>
        <small>UCs worth of</small>
        <h3>800 USD</h3>
        <!--    <img src="assets/img/reno-cup/cash-logo.png" width="100" alt="">-->
      </div>
      <div class="item">
        <h1>Invitational Tournament</h1>
        <h3>3000 USD</h3>
        <!--    <img src="assets/img/reno-cup/iphone-logo.png" height="100" alt="">-->
      </div>
      <div class="item">
        <h1>Open Tournaments</h1>
        <h3>12 Reno5 Phones</h3>
<!--        <img src="assets/img/reno-cup/ps4-logo.png" width="100" alt="">-->
      </div>
    </div>
  </perfect-scrollbar>
</div>

<div class="container">
  <div class="tournaments-container">
    <div class="items" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">

      <div class="items-status" [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>
      <div class="col-sm-6 col-xs-12">
        <a class="tag-container"
           [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}"
           href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank">
          <div class="overlay-cover {{gameName}}"></div>

          <div class="tag-text tag-3-text">

            <div class="text">
              <h1>{{tournament.name}}</h1>

              <div class="status hidden-lg hidden-md hidden-sm"
                   style="display: flex; justify-content: flex-start; align-items: center; direction: ltr;">

                <p style="flex-grow: 1; display: flex; flex-flow: column">
                                                <span class="row">
                                                <i class="icon-calendar"></i>
                                                  {{globalService.Date(tournament.start_at)}}
                                                </span>

                  <span class="row">
                                                <i class="icon-clock"></i>
                    {{globalService.Time(tournament.start_at)}},
                    {{tournament.time_zone}}
                                                </span>
                </p>

                <div class="icon"
                     [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

                <p *ngIf="tournament.status=='Waiting Players to Join'">Open</p>
                <p *ngIf="tournament.status=='inprogress'">In Progress</p>
                <p *ngIf="tournament.status=='Finished'">Finished</p>
                <p *ngIf="tournament.status=='Registration Closed'">Closed</p>
              </div>

            </div>

          </div>
        </a>

      </div>

      <div class="col-sm-6 hidden-xs">

        <div class="info">
          <div class="item">
            <svg-icon name="calendar"></svg-icon>
            <p>
              {{globalService.Date(tournament.start_at)}}
              {{globalService.Time(tournament.start_at)}},
              {{tournament.time_zone}}
            </p>
          </div>

          <h1>{{tournament.name}}</h1>

          <div class="status" style="display: flex; justify-content: flex-start; align-items: center;">

            <div class="icon"
                 [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

            <p *ngIf="tournament.status=='Waiting Players to Join'">Open</p>
            <p *ngIf="tournament.status=='inprogress'">In Progress</p>
            <p *ngIf="tournament.status=='Finished'">Finished</p>
            <p *ngIf="tournament.status=='Registration Closed'">Closed</p>

          </div>

        </div>


        <a href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank"
           class="button">
          <svg-icon name="gamebar"></svg-icon>
          <p>Join Now</p>
        </a>

      </div>
    </div>
  </div>

  <div class="no-data " *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
    <p>
      لم يتم إضافة بطولات
      بعد
    </p>
  </div>
</div>


